import { DateOptions, IConfiguredTrafficReport } from "./IConfiguredTrafficReport";
import { AggregationPeriod } from "@app/shared";
import { downloadFacilityUsageCSV, GetFacilityUsageDataLoader } from "./FacilityUsageDataLoader";
import { formatInTimeZone } from "date-fns-tz";

export const FacilityUsageByDay = {
    name: "by Day",
    description: "This report shows the total Inbound/Outbound Targets in the Location by day for the specified range ",
    component: GetFacilityUsageDataLoader(AggregationPeriod.Day, (zone, period) => formatInTimeZone(period, zone, 'MMM dd yyyy')),
    downloadData: opts => downloadFacilityUsageCSV(AggregationPeriod.Day, opts),
    defaultChartType: 'bar',
    defaultRange: DateOptions.ThisMonth,
    key: 'fud',
    config: {
        requiresMonth: false,
        allowsCustomRange: true,
        requiresYear: false,
        allowTargetTypeGrouping: true,
        disabled: false,
        disallowChartTypeToggling: true
    }
} as IConfiguredTrafficReport;